const ErrorMessage = props => <div>{JSON.stringify(props)}</div>;

export default ErrorMessage;
